import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Loader from "../components/loader";
import "./AdminLogin.css";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/admin/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          credentials: "include"
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Admin login failed");
      } else {
        localStorage.setItem("adminLoggedIn", "true");
        navigate(`/admin/dashboard/${process.env.REACT_APP_ADMIN_PATH}/en-list/admin`, { replace: true });
      }
    } catch (err) {
      setError("Something went wrong");
    }

    setLoading(false);
  };

  if (loading) return <Loader />;

  return (
    <div className="admin-auth-wrapper">
      <form className="admin-auth-card" onSubmit={handleSubmit}>
        <h2 className="admin-auth-title">Admin Login</h2>

        <div className="admin-auth-input">
          <FaEnvelope />
          <input
            name="email"
            type="email"
            placeholder="Admin Email"
            onChange={handleChange}
            required
          />
        </div>

        <div className="admin-auth-input">
          <FaLock />
          <input
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            onChange={handleChange}
            required
          />
          <span
            className="admin-auth-eye"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>

        {error && <p className="admin-auth-error">{error}</p>}

        <button className="admin-auth-btn">Login</button>

      </form>
    </div>
  );
}
